import React, { useState } from "react";
import OriginalTimeKeeper from "react-timekeeper";

const TimeKeeper = ({
  name,
  label,
  value,
  error,
  help,
  coarseMinutes,
  onSimpleChange,
  ...rest
}) => {
  const [time, setTime] = useState(value);
  const [showTime, setShowTime] = useState(false);

  return (
    <div className="form-group">
      {!showTime && label && <label htmlFor={name}>{label}</label>}
      {showTime && (
        <OriginalTimeKeeper
          time={time}
          hour24Mode={true}
          coarseMinutes={coarseMinutes ? coarseMinutes : 15}
          forceCoarseMinutes
          onChange={newTime => {
            setTime(newTime.formatted24);
          }}
          doneButton={newTime => (
            <div
              style={{ textAlign: "center", padding: "10px 0", color: "black" }}
              onClick={() => {
                setShowTime(false);
                onSimpleChange({ name: name, value: time });
              }}
            >
              <p>fertig</p>
            </div>
          )}
          {...rest}
        />
      )}
      {!showTime && (
        <p className="form-control" onClick={() => setShowTime(true)}>
          {time}
        </p>
      )}

      {help && (
        <small id={`${name}Help`} className="form-text text-muted">
          {help}
        </small>
      )}
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default TimeKeeper;
